// footer__middle
import { addElements } from './scroll';

const $middle = document.querySelector('.footer__middle');

addElements($middle);

const middleInView = () => {
	$middle.classList.add('footer__middle--show-arrow');
	$middle.removeEventListener('inView', middleInView);
};

$middle.addEventListener('inView', middleInView);
